import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'

import Input from '../../../components/BaseUI/Input'
import Button from '../../../components/BaseUI/Button'
import Content from '../Content'

import styles from './RecoverPassword.module.scss'
import { useTitle } from '../../../hooks/useTitle'
import { Toast, ToastContainer } from '../../../components/CustomUI/Toast'

const API_URL =
  process.env.REACT_APP_API_URL || 'https://dm.aibuddyassistant.com/api'

export default function RecoverPassword() {
  const navigate = useNavigate()

  useTitle('Восстановление пароля | AIBuddy CRM')

  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [toast, setToast] = useState(null)
  const [sent, setSent] = useState(false)

  const handleSubmit = async () => {
    if (!email.trim()) {
      setToast({
        id: 1,
        title: 'Ошибка',
        description: 'Введите email',
        appearance: 'danger',
      })
      return
    }

    setLoading(true)
    setToast(null)

    try {
      await axios.post(`${API_URL}/auth/forgot-password`, {
        email: email.trim().toLowerCase(),
      })

      setSent(true)
      setToast({
        id: 1,
        title: 'Письмо отправлено',
        description:
          'Если аккаунт существует, ссылка для сброса пароля отправлена на указанный email.',
        appearance: 'success',
      })
    } catch (error) {
      console.error('Forgot password error:', error)
      setToast({
        id: 1,
        title: 'Ошибка',
        description: 'Не удалось отправить письмо. Попробуйте позже.',
        appearance: 'danger',
      })
    } finally {
      setLoading(false)
    }
  }

  const removeToast = () => {
    setToast(null)
  }

  return (
    <div className={styles['recover-password-container']}>
      <Content title={sent ? 'Проверьте почту' : 'Восстановление пароля'}>
        {sent ? (
          <div className={styles.content}>
            <div className={styles.iconSuccess}>
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
            </div>
            <p className={styles['message']}>
              Если аккаунт с указанным email существует, ссылка для сброса
              пароля была отправлена на {email}.
            </p>
            <p className={styles.hint}>
              Ссылка действительна 1 час. Проверьте папку "Спам".
            </p>
            <div className={styles.actions}>
              <Button
                title="Войти в систему"
                appearance="primary"
                isBlock={true}
                onClick={() => navigate('/login')}
              />
            </div>
          </div>
        ) : (
          <>
            <p className={styles['message']}>
              Введите email, указанный при регистрации. Мы отправим вам ссылку
              для сброса пароля.
            </p>

            <div className="mt-4">
              <Input
                type="email"
                label="Email"
                placeholder="Введите ваш email"
                className={styles['custom__input']}
                value={email}
                onChange={value => setEmail(value)}
              />
            </div>

            <div className="mt-2">
              <Button
                title={loading ? 'Отправка...' : 'Отправить ссылку'}
                appearance="primary"
                isBlock={true}
                onClick={handleSubmit}
                disabled={loading}
              />
            </div>

            <div className={styles['register']}>
              <span>Вспомнили пароль?</span>
              <span
                className={styles['create__account']}
                onClick={() => navigate('/login')}
              >
                Войти
              </span>
            </div>
          </>
        )}
      </Content>

      {toast && (
        <ToastContainer onDismissed={removeToast}>
          <Toast {...toast} isExpanded />
        </ToastContainer>
      )}
    </div>
  )
}
